export const AUTH_SIGNIN = "AUTH_SIGNIN";
export const AUTH_SIGNOUT = "AUTH_SIGNOUT";
export const AUTH_UPDATE = "AUTH_UPDATE";


export const signInAction = token => {
  if (token) {
    localStorage.setItem("token", token);
    return { type: AUTH_SIGNIN };
  }
};

export const signOutAction = () => {
  localStorage.clear();
  return { type: AUTH_SIGNOUT };
};

export const authUpdateAction = (name, role, id) => {
  return { type: AUTH_UPDATE, role: role, name: name, id: id };
};




// WEBPACK FOOTER //
// ./src/actions/auth_actions.js